import React, { FC } from 'react';
import { T } from 'src/shared/helpers';
import MdArrowBack from 'src/shared/material_icons/navigation/arrow_back.svg';
import { BasicButton } from '../../../widgets/buttons';
import { Icon } from '../../../widgets/icon';

// Shared back control for the setup-wizard step footers. Uses the secondary "second-level" button
// style (outlined, themed orange border) — the same weight as the forward actions like "Go to variants" —
// instead of the low-emphasis TextButton, so the back is clearly visible.
export const WizardFooterBackButton: FC<{ onClick: () => void; label?: string }> = ({ onClick, label }) => (
    <BasicButton $size='large' type='button' onClick={onClick}>
        <Icon>
            <MdArrowBack />
        </Icon>
        {label ?? T._('Back', 'Admin')}
    </BasicButton>
);
